module.exports = __webpack_public_path__ + "static/Peter-Gruber-a3dc679785707e9064b3a19a86e32ada.jpg";